import api from "@/lib/axios";

export const getBranches = async () => {
  const { data } = await api.get("/branches");
  return data.data;
};

export const createBranch = async (payload) => {
  const { data } = await api.post("/branches", payload);
  return data.data;
};

export const updateBranch = async (id, payload) => {
  const { data } = await api.patch(`/branches/${id}`, payload);
  return data.data;
};

export const updateBranchRank = async (ranks) => {
  const { data } = await api.patch("/branches/rank", { ranks });
  return data.data;
};

export const uploadBranchImage = async (id, formData) => {
  const { data } = await api.patch(`/branches/${id}/image`, formData);
  return data.data;
};

export const removeBranchImage = async (id) => {
  const { data } = await api.delete(`/branches/${id}/image`);
  return data.data;
};

export const deleteBranch = async (id) => {
  const { data } = await api.delete(`/branches/${id}`);
  return data.data;
};

export const getBranchOverrides = async (branchId) => {
  const { data } = await api.get(`/branches/${branchId}/overrides`);
  return data.data;
};

export const upsertBranchOverride = async (branchId, productId, payload) => {
  const { data } = await api.put(
    `/branches/${branchId}/products/${productId}`,
    payload,
  );
  return data.data;
};

export const deleteBranchOverride = async (branchId, productId) => {
  const { data } = await api.delete(
    `/branches/${branchId}/products/${productId}`,
  );
  return data.data;
};

export const getBranchCategoryOverrides = async (branchId) => {
  const { data } = await api.get(`/branches/${branchId}/category-overrides`);
  return data.data;
};

export const upsertBranchCategoryOverride = async (
  branchId,
  categoryId,
  payload,
) => {
  const { data } = await api.put(
    `/branches/${branchId}/categories/${categoryId}`,
    payload,
  );
  return data.data;
};

export const bulkBranchOverrides = async (branchId, items) => {
  const { data } = await api.put(`/branches/${branchId}/bulk-overrides`, {
    items,
  });
  return data.data;
};

export const pushBranchProductPrice = async (branchId, productId) => {
  const { data } = await api.post(
    `/branches/${branchId}/products/${productId}/push`,
  );
  return data.data;
};

// ---------- Şubeye özel menü sırası ----------
// Marka sırası tenant geneli; bunlar yalnızca bu şubenin menüsünü etkiler. Liste her seferinde
// tam gönderilir — yarım gönderim menüde marka sırasıyla karışan bir sıra üretir.

export const setBranchCategoryRanks = async (branchId, ranks) => {
  const { data } = await api.put(`/branches/${branchId}/categories/rank`, {
    ranks,
  });
  return data.data;
};

export const resetBranchCategoryRanks = async (branchId) => {
  const { data } = await api.delete(`/branches/${branchId}/categories/rank`);
  return data.data;
};

export const setBranchProductRanks = async (branchId, ranks) => {
  const { data } = await api.put(`/branches/${branchId}/products/rank`, {
    ranks,
  });
  return data.data;
};

export const resetBranchProductRanks = async (branchId, productIds) => {
  const { data } = await api.delete(`/branches/${branchId}/products/rank`, {
    data: { productIds },
  });
  return data.data;
};
